import React from 'react';
import strelitziaImg from '../assets/STRELITZIA.webp';
import cu4a3770Img from '../assets/CU4A3770.webp';
import cu4a3989Img from '../assets/CU4A3989.webp';
import cu4a3854Img from '../assets/CU4A3854.webp';

const RinconesEncanto = () => {
  const rincones = [
    {
      id: 1,
      texto: "Flores y plantas que transforman tu espacio y dan vida a esos lugares escondidos. Florece y purifica tu hogar.",
      imagen: strelitziaImg,
      alt: "Strelitzia - Planta tropical",
      isTextRight: false
    },
    {
      id: 2,
      texto: "La interacción de los estímulos olfativos y visuales con las plantas y flores relajan y refrescan nuestro cuerpo.",
      imagen: cu4a3770Img,
      alt: "Plantas que relajan el cuerpo",
      isTextRight: true
    },
    {
      id: 3,
      texto: "Mejora la memoria; La exposición al aroma de las rosas nos ayuda a retener información mientras dormimos.",
      imagen: cu4a3989Img,
      alt: "Rosas para mejorar la memoria",
      isTextRight: false
    },
    {
      id: 4,
      texto: "Sabías que varios estudios han demostrado que oler flores puede mejorar el estado de ánimo y reducir el estrés.",
      imagen: cu4a3854Img,
      alt: "Flores para mejorar el estado de ánimo",
      isTextRight: true
    }
  ];

  return (
    <section id="rincones" className="rincones-encanto">
      <div className="container">
        <h2 className="section-title">Rincones con encanto</h2>
        
        <div className="rincones-grid">
          {rincones.map((rincon) => (
            <div 
              key={rincon.id} 
              className={`rincon-item ${rincon.isTextRight ? 'text-right' : ''}`}
            >
              <div className="rincon-text">
                <p>{rincon.texto}</p>
              </div>
              <div className="rincon-image">
                <img src={rincon.imagen} alt={rincon.alt} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RinconesEncanto;
